'use strict';

var _ = require('lodash');
var Actions = require('./lib/Actions');
var Dispatcher = require('./lib/Dispatcher');
var Store = require('./lib/Store');

function FluxUtil ($injector) {
  _.extend(this, {
    Actions: $injector.invoke(Actions),
    Dispatcher: $injector.invoke(Dispatcher),
    Store: $injector.invoke(Store)
  });
}

FluxUtil.$inject = ['$injector'];
module.exports = FluxUtil;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/flux/src/FluxUtil.js